var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditSharedResourceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173287"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29957",
    d: "m12.4 5.779-1.072-1.436A.857.857 0 0 0 10.643 4H5.929a.857.857 0 0 0-.686.343L4.171 5.779A.879.879 0 0 0 4 6.293v5.421a.857.857 0 0 0 .857.857h6.857a.857.857 0 0 0 .857-.857V6.293a.879.879 0 0 0-.171-.514zm-6.471-.922h4.714l.964 1.286H4.964zm5.786 6.857H4.857V7h3v2.4L7.3 8.843a.407.407 0 0 0-.643.043.45.45 0 0 0 .043.579l1.286 1.264a.407.407 0 0 0 .6 0l1.285-1.265a.45.45 0 0 0 .043-.579.407.407 0 0 0-.643-.043l-.557.558V7h3z",
    transform: "translate(-2.285 -1.785)",
    style: {
      fill: "#231f20"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSharedResourceIcon);
export default __webpack_public_path__ + "static/media/edit-shared-resource-icon.39fc1de3846eb0ed4ed5c0410ced7849.svg";
export { ForwardRef as ReactComponent };